<div class="tab-pane active">
    <div class="support-contact">
        <div class="support-contact">
            <div *ngIf="showGetInTouch">
                <div class="public-page-title">
                    Get In Touch
                </div>
                <p class="public-intro">
                    Send a quick email or call directly for any questions you may have to speak with your dedicated support representative:
                </p>
                <div class="row mb-5">
                    <div class="col-auto" *ngIf="salesRep?.image_url">
                        <img [src]="salesRep?.image_url || ''"
                            style='height: 150px'/>
                    </div>
                    <div class="col support-contact-info">
                        <div class="public-h2">
                            {{ salesRep?.first_name }} {{ salesRep?.last_name }}
                        </div>
                        <div class="support-contact-item">
                            <div class="support-contact-icon">
                                <svg ycnIcon name="icon-mail"></svg>
                            </div>
                            <a class="public-cta" href="mailto:{{ salesRep?.email }}">{{ salesRep?.email }}</a>
                        </div>
                        <div class="support-contact-item">
                            <div class="support-contact-icon">
                                <svg ycnIcon name="icon-phone"></svg>
                            </div>
                            <span class="public-cta">{{ salesRep?.phone_number }}</span>
                        </div>
                        <div class="support-contact-item">
                            <div class="support-contact-icon">
                                <svg ycnIcon name="icon-team"></svg>
                            </div>
                            <a class="public-cta" *ngIf="salesRep" href="{{salesRep.meeting_url}}">Book a Meeting
                                with {{salesRep.first_name}}</a>
                        </div>
                        <small>Office hours: Monday to Friday, from 9am to 6pm ET.</small>
                    </div>
                </div>
                <hr class="divider-horizontal mb-5"/>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="public-page-title">
                        Customer Support
                    </div>
                    <div class="support-contact-item">
                        <div class="support-contact-icon">
                            <svg ycnIcon name="icon-mail"></svg>
                        </div>
                        <a class="public-cta" href="mailto:support@ycharts.com">support&#64;ycharts.com</a>
                    </div>
                    <div class="support-contact-item">
                        <div class="support-contact-icon">
                            <svg ycnIcon name="icon-phone"></svg>
                        </div>
                        <span class="public-cta">(866) 965-7552</span>
                    </div>
                    <div class="support-contact-item">
                        <div class="support-contact-icon">
                            <svg ycnIcon name="icon-overview"></svg>
                        </div>
                        <a class="public-cta" href="https://ycharts.com/sales_support/contact">Submit a question</a>
                    </div>
                    <div class="support-contact-item" *ngIf="chatEnabled">
                        <div class="support-contact-icon">
                            <svg ycnIcon name="icon-chat-small"></svg>
                        </div>
                        <a class="public-cta" href="javascript:void(0);" onclick="window.openHubSpotChat();">Live chat</a>
                    </div>
                </div>
                <div class="col-6">
                    <div class="public-page-title">
                        Sales Team
                    </div>
                    <div class="support-contact-item">
                        <div class="support-contact-icon">
                            <svg ycnIcon name="icon-mail"></svg>
                        </div>
                        <a class="public-cta" href="mailto:sales@ycharts.com">sales&#64;ycharts.com</a>
                    </div>
                    <div class="support-contact-item">
                        <div class="support-contact-icon">
                            <svg ycnIcon name="icon-phone"></svg>
                        </div>
                        <span>(866) 937-0776</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
